<template>
    <div class="container">
        <img src="/static/core/img/migdal-logo.jpg" style="display: block; margin: 50px auto 24px" />

        <h4 class="text-center">CMS</h4>

        <form class="form-signin" @submit.prevent="login">
            <p>
                <label for="username" class="sr-only">Username</label>
                <input type="text" id="username" name="username" class="form-control" placeholder="Username" required
                    autofocus v-model="data.username" />
            </p>
            <p>
                <label for="password" class="sr-only">Password</label>
                <input type="password" id="password" name="password" class="form-control" placeholder="Password" required
                    v-model="data.password" />
            </p>
            <div v-if="state.error" class="error-msg">
                {{ state.error }}
            </div>
            <Loader v-if="isLoadingAny" class="mx-auto" color="#007bff" />
            <button v-else style="cursor: pointer" class="btn btn-lg btn-primary btn-block">Sign in</button>
        </form>
    </div>
</template>

<script>
import Loader from '../../common/common-components/Loader/v2/Loader'
import useLoading, { isLoadingAny } from "../../common/composables/useLoading"

import $auth from "../../common/state/$auth"

import swal from 'sweetalert'

export default {
    name: 'Login',
    data() {
        return {
            data: {
                username: '',
                password: ''
            },
            state: {
                error: null,
            }
        }
    },
    components: {
        Loader
    },
    computed: {
        $auth() {
            return $auth.value
        },
        isLoadingAny() {
            return isLoadingAny.value
        },
    },
    methods: {
        async login() {
            console.log("env", process.env);
            const { startLoadingThis, stopLoadingThis } = useLoading()
            try {
                startLoadingThis()
                const { username, password } = this.data
                if (username=='test') {
                    swal('The username test will be soon disabled', 'Please contact us to obtain your access', 'info')
                }
                await this.$auth.login({ username, password })
            } catch (err) {
                this.state.error = err.message
            } finally {
                stopLoadingThis()
            }
        }
    }
}
</script>

<style>
.error-msg {
    width: 300px;
    margin: 10px auto;
    color: red;
    text-align: center;
}
</style>